"use client";
import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import OTPLogin from './OTPLogin';
import VerifyOTP from '@/app/_components/VerifyOTP';


interface OTPFlowProps {
  onSwitchToEmail: () => void;
}

const OTPFlow = ({ onSwitchToEmail }: OTPFlowProps) => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState('');
  const router = useRouter();

  const handleOTPSuccess = () => {
    router.push('/dashboard');
  };

  const handlePhoneSubmit = (phoneNumber: string) => {
    setPhone(phoneNumber);
    setStep(2);
  };

  return (
    <>
      {step === 1 && (
        <OTPLogin 
          onSwitchToEmail={onSwitchToEmail}
          onNext={handlePhoneSubmit}
        />
      )}
      {step === 2 && (
        <VerifyOTP 
          phoneNumber={phone}
          onNext={handleOTPSuccess}
        />
      )}
    </>
  );
};

export default OTPFlow;